import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35085808"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card p-4" }
const _hoisted_2 = { class: "p-1 m-0 h-auto" }
const _hoisted_3 = { class: "d-flex justify-content-between w-100 border-bottom py-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-blue" }, "Mis grupos", -1))
const _hoisted_5 = { class: "card-body p-2 overflow-auto" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "d-flex align-items-center me-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-light rounded-circle" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "media/svg/brand-logos/blank.png",
      alt: "",
      class: "h-50"
    })
  ])
], -1))
const _hoisted_9 = {
  href: "#",
  id: "nombre",
  class: "fs-6 text-gray-800"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-block text-end text-gray" }, [
    /*#__PURE__*/_createElementVNode("p", null, "15"),
    /*#__PURE__*/_createElementVNode("p", null, "Integrantes")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "mi-grupo-agregar-grupo",
          class: "bi bi-plus text-blue fw-bolder fs-1"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grupos, (grupo, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "d-flex mb-2 justify-content-between",
          key: i,
          value: grupo._id
        }, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(grupo.nombre), 1)
            ])
          ]),
          _hoisted_10
        ], 8, _hoisted_6))
      }), 128))
    ])
  ]))
}